var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLogout(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "22px",
    viewBox: "0 0 24 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "62C1A7E1-4A8C-4A23-A2AB-52E1ACC9C9D3@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8-Style-Guide",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Style-Guide",
    transform: "translate(-419.000000, -3772.000000)",
    fill: "#0000008a",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.-Icon/Placeholder",
    transform: "translate(413.000000, 3767.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.872,5.5 C16.696,5.5 17.365,6.169 17.365,6.993 C17.365,7.818 16.696,8.486 15.872,8.486 L15.872,8.486 L8.986,8.486 L8.986,23.956 L15.872,23.956 C16.696,23.956 17.365,24.625 17.365,25.449 C17.365,26.273 16.696,26.942 15.872,26.942 L15.872,26.942 L8,26.942 C6.8954305,26.942 6,26.0465695 6,24.942 L6,24.942 L6,7.5 C6,6.3954305 6.8954305,5.5 8,5.5 L8,5.5 Z M22.0739,10.1869 C22.6579,9.6029 23.6019,9.6029 24.1859,10.1869 L24.1859,10.1869 L29.9999,15.9989 L28.9979,17.0009 C28.9609,17.0429 28.9209,17.0829 28.8789,17.1209 L28.8789,17.1209 L24.1639,21.8359 C23.8719,22.1279 23.4899,22.2729 23.1069,22.2729 C22.7259,22.2729 22.3439,22.1279 22.0529,21.8359 C21.4689,21.2529 21.4689,20.3079 22.0529,19.7249 L22.0529,19.7249 L24.2709,17.5039 L13.2649,17.5039 C12.4389,17.5039 11.7709,16.8349 11.7709,16.0109 C11.7709,15.1869 12.4389,14.5179 13.2649,14.5179 L13.2649,14.5179 L24.2949,14.5179 L22.0739,12.2979 C21.4909,11.7149 21.4909,10.7699 22.0739,10.1869 Z",
    id: "\\u21B3Select-Color"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/icon_Logout.9021c75682eff71e4a47bb546f93578a.svg";
export { ForwardRef as ReactComponent };